import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { configData } from "../../../config/systemconfigurationconstants";
import * as AWS from 'aws-sdk';
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../../../customHooks/useEncryption';
let getusecaseinfo = []
const UpdateMasterData = () => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const [usecase, setUsecase] = useState("");
    const [usecasename, setUsecasename] = useState("");
    const [client, setClient] = useState("");
    const [clientname, setClientname] = useState("");
    const [clientList, setClientList] = useState([]);
    const [showConfigureRule, setShowConfigureRule] = useState(false);
    const [disabledsave, setDisabledsave] = useState(true);
    const [dotloader, setDotLoader] = useState(false);
    const [usecaseError, setUsecaseError] = useState('');
    const [clientError, setClientError] = useState('');
    const [selectedUsecase, setSelectedUsecase] = useState('');
    const [selectedClient, setSelectedClient] = useState('');
    const [configiuidata, setConfigiuidata] = useState([])

    useEffect(() => {
        console.log("masterjsonupdate", JSON.parse(localStorage.getItem("usecaseInfo")))
        getusecaseinfo = JSON.parse(localStorage.getItem("usecaseInfo"))
    }, [])
    useEffect(() => {
        setClient("")
        setUsecase("")
    }, [])
    const handleUsecaseChange = (value) => {
        setUsecase(value);
        let selectedUsecase = JSON.parse(localStorage.getItem("usecaseInfo")).find(x => x.UseCaseId == value);
        setSelectedUsecase(selectedUsecase.UCSN)
        let getClientListUnderSelectedUseCase = selectedUsecase ? selectedUsecase.Client : [];
        setClientList(getClientListUnderSelectedUseCase)
    }
    const handleclientchange = (e) => {
        setClient(e.target.value);
        let getclientname = clientList.find(x => x.ClientID == e.target.value)
        setSelectedClient(getclientname.CSN)
        ruleConfigForUi(getclientname.CSN);
    }
    const ruleConfigForUi = async (clientname) => {
        setDotLoader(true);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.GET_CONFIG_FOR_UI,
            ClientShortName: clientname,
            UseCaseShortName: selectedUsecase
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };

        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
                const parsedBody = JSON.parse(parsedPayload.body);
                setConfigiuidata(parsedBody)
                // setUploadIdxBucket(parsedBody.IDXBucket)
                // setIdxAWSAccessKey(parsedBody.IDXAWSAccessKey)
                // setIdxAWSSecretKey(parsedBody.IDXAWSSecretKey)
                // setConfigjson(parsedBody);
                // setTimeout(() => {
                //     setDotLoader(true);
                // }, 1000);

            }
            else {
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
            }
        } catch (error) {
            // setDotLoader(false);
            console.error('Error in getCurrentRpm:', error);
            setTimeout(() => {
                setDotLoader(false);
            }, 1000);
        }

        // setDotLoader(false);
        // try {
        //     const parsedBody = await invokeLambda(configData.GET_CONFIG_FOR_UI, {
        //         // ...lambdaConfig,
        //         // SecurityToken: localStorage.getItem('SecurityToken'),
        //         ClientShortName: localStorage.getItem('ClientShortName').trim(),
        //         UseCaseShortName: localStorage.getItem('UseCaseShortName').trim()
        //     });

        //     if (parsedBody.Status) {
        //         setUploadIdxBucket(parsedBody.IDXBucket);
        //         // setUserDetails(parsedBody.UserInfo)
        //         // setUseCaseListForUserCreation(parsedBody.UseCaseClientInfo[0].UseCase)
        //         // setUserRoleListForUserCreation(parsedBody.UserRoleInfo)
        //         // setUserProviderForUserCreation(parsedBody.Prvdrslst)
        //         // setTimeout(() => {
        //         //     setDotLoader(true);
        //         // }, 1000);
        //     } else {
        //         // setDotLoader(false);
        //     }
        // } catch (err) {
        //     // Handle error if needed
        //     // setDotLoader(false);

        // }
    }
    const validateForm = () => {
        let valid = true;

        if (!usecase) {
            setUsecaseError("Usecase is required");
            valid = false;
        } else {
            setUsecaseError("");
        }

        if (!client) {
            setClientError("Client is required");
            valid = false;
        } else {
            setClientError("");
        }

        return valid;
    };

    const uploadMasterJson = async () => {
        if (!validateForm()) return; // ❌ stop if invalid
        setDotLoader(true);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.UPDATE_CLIENT_MASTER_JSON,
            SecurityId: "",
            SecurityToken: localStorage.getItem('SecurityToken'),
            userName: localStorage.getItem("UserName"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: "",
            IDXBucket: configiuidata.IDXBucket,
            IDXClientShortName: configiuidata.IDXCSN,
            IDXUseCaseShortName: configiuidata.IDXUCSN,
        };

        const params = {
            FunctionName: "GDXUIWrapper",
            Payload: JSON.stringify(payloadData)
        };

        try {
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
                const parsedBody = JSON.parse(parsedPayload.body);
                toast.success(parsedBody.Output, {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                canceluplodmasterjson()
            }
            else {
                setTimeout(() => {
                    setDotLoader(false);
                }, 1000);
                toast.error("Master.json Upload Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                canceluplodmasterjson();
            }
        } catch (error) {
            console.error('Error in uploadMasterJson:', error);
        }
    };
    const canceluplodmasterjson = () => {
        setClient("")
        setUsecase("")
    }
    return (
        <>
            {!dotloader ? (
                <Alert variant="light">
                    <Row>
                        <Col sm={4}>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label className='text-end'>
                                        Usecase Name<span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={usecase}
                                        onChange={(e) => {
                                            handleUsecaseChange(e.target.value);
                                            if (e.target.value) setUsecaseError('');
                                        }}
                                    >
                                        <option value="" disabled>Select Usecase</option>
                                        {JSON.parse(localStorage.getItem("usecaseInfo"))?.map((el) => (
                                            <option key={el.UseCaseId} value={el.UseCaseId}>
                                                {el.UseCaseName}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    {usecaseError && <div style={{ color: 'red', fontSize: '0.8rem' }}>{usecaseError}</div>}
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className='text-end'>
                                        Client<span style={{ color: 'red' }}>*</span>
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={client}
                                        onChange={(e) => {
                                            handleclientchange(e);
                                            if (e.target.value) setClientError('');
                                        }}
                                    >
                                        <option value="">Select Client</option>
                                        {clientList.map((option, idx) => (
                                            <option key={idx} value={option.ClientID}>{option.ClientName}</option>
                                        ))}
                                    </Form.Select>
                                    {clientError && <div style={{ color: 'red', fontSize: '0.8rem' }}>{clientError}</div>}
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={4} className='text-end'>
                            <Button variant="outline-primary" size='sm' className='me-1' onClick={canceluplodmasterjson}>Cancel</Button>
                            <Button
                                variant="primary"
                                size='sm'
                                onClick={uploadMasterJson}
                                disabled={!usecase || !client} // disable until valid
                            >
                                Go
                            </Button>
                        </Col>
                    </Row>
                </Alert>) : (<div
                    style={{ marginTop: "20%", marginBottom: "20%" }}
                    className="d-flex justify-content-center"
                >
                    <div className="loader"></div>
                </div>)
            }

        </>
    );
}

export default UpdateMasterData